"use client"
import Title from "@/components/Title/Title"
import { CareerForm } from "@/components/CareerForm/CareerForm"
import "aos/dist/aos.css"

export function CareerContent() {
  return (
    <main>
      <div className="flex w-full xl:p-8 overflow-hidden  overflow-x-hidden min-h-[240px] max-h-[680px] 3xl:max-h-[1080px] group relative">
        <div className="overflow-hidden w-full">
          <img
            src="/bg-cyber.jpg"
            width={1920}
            height={680}
            alt="Cyberstone Careers"
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover object-center transition-transform duration-300 group-hover:scale-110"
          />
          <Title
            title="cyberstone careers"
            type="h2"
            className="absolute inset-0 flex items-center left-16 text-white"
          />
        </div>
      </div>
      <article className="flex px-6 sm:px-5 xl:px-16 3xl:px-24 py-8 sm:py-16 bg-[--color-blue] relative">
        <div
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-delay="400"
          className="flex absolute left-0 top-8 sm:top-16 w-full sm:w-[calc(100%-6rem)] h-[calc(100%-2rem)] sm:h-[calc(100%-8rem)] bg-white"
        ></div>
        {/* Responsive grid: 1 column on mobile, 2 on large screens */}
        <div
          className="grid grid-cols-1 lg:grid-cols-2 py-12 sm:py-24 bg-white px-0 sm:pe-5 xl:pe-16 3xl:pe-24 w-full relative z-20 gap-8 lg:gap-20 3xl:gap-80"
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-delay="400"
        >
          {/* Sticky section in first column, sticky only on lg+ */}
          <div className="lg:sticky lg:top-64 h-fit mb-2  xl:mb-12 lg:mb-0">
            <div className="flex flex-col gap-6 sm:gap-9">
              <Title
                title="for professional growth"
                black="cyberstone "
                orange="is a company "
                grey=" with wide opportunities "
                type="h2"
                className="uppercase text-[24px] xl:text-[60px] 2xl:text-[72px]"
              />
              <p className="  leading-[150%]">
                Being a leading pure-play Information Security provider, we have
                one of the largest pools of trained and certified security
                professionals. From consulting to analysis, software development
                to engineering, quality assurance to sales and marketing, Cyber
                Stone offers a wide range of opportunities for you to build your
                career the way you aspire to be.
                <br />
                <br />
                Cyber Stone is full of smart and dedicated people, who are
                actively involved with the company&apos;s proceedings enabling
                organizations across the world to manage their technology risks
                and create a fully assured business environment. Our people are
                our real strength and are the most integrated partners in the
                company&apos;s growth story.
                <br />
                <br />
                Innovation and dedication count for us the most. Whether you are
                a fresher or an experienced professional, Cyber Stone salutes
                those who thrive to excel and creates a platform where you can
                cultivate your knowledge and expertise and reinvent your skills.
                <br />
                <br />
                At Cyber Stone, we understand the needs of our employees and
                offer them competitive and industry-standard packages and
                benefits along with an open and flexible work culture to promote
                a perfect work-life balance.
              </p>
            </div>
          </div>

          <div className="flex w-full">
            <CareerForm />
          </div>
        </div>
      </article>
    </main>
  )
}
